import { AMPLITUDE_GROUP_TYPE, buildAmplitudeUserTraits } from '@/utilities/amplitudeUserTraits.js';
import { getAmplitudeVertical } from '@/utilities/amplitudeVertical.js';

/**
 * @param {import('@amplitude/analytics-browser')} amplitudeClient
 * @param {Object} user
 * @param {string} instanceId
 * @returns {Promise<{ roleNames: string[], groupNames: string[], amplitudeGroupNames: string[], groupsTruncated: boolean, vertical: string }>}
 */
export const syncAmplitudeUserProfile = async (amplitudeClient, user, instanceId) => {
    if (!user?.id) {
        console.debug('[Amplitude] Skipping user profile sync - no user id available');

        return {
            roleNames: [],
            groupNames: [],
            amplitudeGroupNames: [],
            groupsTruncated: false,
            vertical: getAmplitudeVertical(),
        };
    }

    const userId = user.id.toString();
    const { roleNames, groupNames, amplitudeGroupNames, groupsTruncated } = buildAmplitudeUserTraits(user);
    const vertical = getAmplitudeVertical();

    if (groupsTruncated) {
        console.debug('[Amplitude] User belongs to more than 10 groups; sending first 10 alphabetically for setGroup');
    }

    const identifyObj = new amplitudeClient.Identify()
        .set('tenant_id', instanceId)
        .set('user_id', userId)
        .set('vertical', vertical)
        .set('role_names', roleNames)
        .set('group_names', groupNames);

    await amplitudeClient.identify(identifyObj).promise;
    amplitudeClient.setGroup(AMPLITUDE_GROUP_TYPE, amplitudeGroupNames);

    console.debug('[Amplitude] Synced user profile:', {
        user_id: userId,
        vertical,
        role_names: roleNames,
        group_names: groupNames,
        amplitude_group_names: amplitudeGroupNames,
        groups_truncated: groupsTruncated,
    });

    return { roleNames, groupNames, amplitudeGroupNames, groupsTruncated, vertical };
};
